import React from "react";
import MarketingLayout from "../../components/layout/marketing/MarketingLayout";

export default function RefundsAndCancellationPolicies() {
    return (
        <MarketingLayout>
            <div className="mx-auto px-8 lg:px-24 py-20 sm:py-24 lg:py-16">
                <header className="mb-12 border-b border-border-subtle pb-8">
                    <h1 className="text-4xl font-bold text-text-primary">
                        Cancellation & <span className="text-primary">Refund Policy</span>
                    </h1>
                    <p className="mt-2 text-sm text-text-muted">Last Updated: January 2026</p>
                </header>

                <div className="space-y-12 text-text-secondary leading-relaxed">
                    <article>
                        <h2 className="text-2xl font-bold text-text-primary mb-4">1. Cancelling of Subscription</h2>
                        <p>
                            You can cancel your paid subscription at any time. Cancellation will stop the next scheduled
                            auto-renewal.
                        </p>
                        <p className="mt-4">
                            <strong>Trial Period:</strong> You may cancel anytime during the 7-day trial period to avoid
                            being charged.
                        </p>
                    </article>

                    <article className="bg-bg-subtle/50 p-8 rounded-2xl border border-border-subtle">
                        <h2 className="text-2xl font-bold text-text-primary mb-4">2. Mid-Cycle Cancellation</h2>
                        <div className="space-y-4">
                            <p>
                                <strong>No Pro-Rata Refunds:</strong> We do not offer refunds for partial months or
                                unused service time.
                            </p>
                            <p>
                                <strong>Service Continuation:</strong> If you cancel mid-cycle, your service will remain
                                active until the end of your current paid period. After this date, the scheduling bot
                                will be deactivated, and you will no longer receive appointment notifications.
                            </p>
                        </div>
                    </article>

                    <article>
                        <h2 className="text-2xl font-bold text-text-primary mb-4">3. Auto-Renewal</h2>
                        <p>
                            To ensure your clinic never misses an appointment, subscriptions automatically renew at the
                            end of each billing cycle (Quarterly/Annual). The renewal charge will be processed using the
                            payment method on file.
                        </p>
                    </article>

                    <article className="p-6 border-l-4 border-red-500 bg-red-50/30">
                        <h2 className="text-2xl font-bold text-text-primary mb-4">4. Platform Policy Violations</h2>
                        <p>
                            Our service relies on the WhatsApp Business API. If your phone number is banned or
                            restricted by WhatsApp/Meta due to a violation of their Commerce or Business Policies, your
                            Eikos Health subscription will be terminated immediately.
                        </p>
                        <p className="mt-4 font-bold text-text-primary italic text-lg">
                            In this specific case, no refunds will be issued for the remaining subscription period.
                        </p>
                    </article>

                    <article>
                        <h2 className="text-2xl font-bold text-text-primary mb-4">5. Price Changes</h2>
                        <p>We reserve the right to modify pricing with 30 days' notice.</p>
                    </article>
                </div>
            </div>
        </MarketingLayout>
    );
}
